module.exports = __webpack_public_path__ + "img/frame (43).be6f6767.jpg";